import { PaginationOption } from "@core/services/http/http.type";

export const DEFAULT_DATE_FORMAT = "D/MM/YYYY";
export const DEFAULT_MINUTES_SECONDS_FORMAT = "mm:ss";

export const ACCESS_TOKEN_KEY = "access_token";

export enum OrderType {
  ASC = "asc",
  DESC = "desc",
}

export enum Role {
  GUEST = "GUEST",
  MEMBER = "MEMBER",
  ADMIN = "ADMIN",
}

export enum SectionType {
  READING = "READING",
  WRITING = "WRITING",
  LISTENING = "LISTENING",
}

export const PAGING_DEFAULT_LIMIT = 20;

export const DEFAULT_PAGINATION_OPTION: PaginationOption = {
  page: 1,
  limit: PAGING_DEFAULT_LIMIT,
};

export enum QuestionType {
  DROPDOWN = "DROPDOWN",
  CHECKBOX = "CHECKBOX",
  IMAGE_TEXT_INPUT = "IMAGE_TEXT_INPUT",
  TABLE_RADIO = "TABLE_RADIO",
  RADIO = "RADIO",
  COLLAPSE_EXPAND_RADIO = "COLLAPSE_EXPAND_RADIO",
  TEXTAREA = "TEXTAREA",
}

export const MAPPING_EXAM_DURATION = {
  [SectionType.LISTENING]: 35,
  [SectionType.READING]: 60,
  [SectionType.WRITING]: 60,
  // [SectionType.LISTENING]: 1,
  // [SectionType.READING]: 1,
  // [SectionType.WRITING]: 1,
};

export enum ExamMode {
  PRACTICE = "PRACTICE",
  STRICT = "STRICT",
}

export enum ExamStatus {
  IN_PROGRESS = "in-progress",
}

export const MAX_MULTIPLE_CHOICES = 2;
